import { render, staticRenderFns } from "./OrderUsages.vue?vue&type=template&id=460cc508&scoped=true&"
import script from "./OrderUsages.vue?vue&type=script&lang=js&"
export * from "./OrderUsages.vue?vue&type=script&lang=js&"
import style0 from "./OrderUsages.vue?vue&type=style&index=0&id=460cc508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460cc508",
  null
  
)

export default component.exports